import React, { useEffect } from "react";
import styles from "./paythank.module.css";
import { Link, useLocation, useHistory } from "react-router-dom";
import { ROUTE } from "../../route/Route";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import SeoAdd from "../Seo/SeoAdd";
import { useTranslation } from "react-i18next";
import { ProfileTabEnum } from "../MyProfile/ProfileTabEnum";
import { useDispatch , useSelector} from "react-redux";
import { setBookingDataResponse } from "../../redux/checkout/reducer";
import { submitAction } from "../../redux/action";
import { Email_BASE_URL } from '../../redux/common/url';

const PaymentThankyou = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { state } = useLocation<any>();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const CustomerName = localStorage.getItem("CustomerName");

  const bookingData: any = useSelector((state: any) =>
    state.checkout.booking ? state.checkout.booking : {}
  );

  useEffect(() => {
    window?.scrollTo(0, 0);
    localStorage.removeItem("CartData");
    localStorage.removeItem("editBooking");
    dispatch(setBookingDataResponse({}));
    // dispatch(submitAction.sendEmailAction());
    // dispatch(submitAction.sendSmsAction());
    const fetchSMS = fetch(`${Email_BASE_URL}/cronjob/notifications/sms`, {
      mode: 'no-cors'
  })
  .then(response => response.json())
  .then(data => {
      console.log('SMS Data:', data);
  })

  const fetchEmail = fetch(`${Email_BASE_URL}/cronjob/notifications/email`, {
      mode: 'no-cors'
  })
  .then(response => response.json())
  .then(data => {
      console.log('Email Data:', data);
  })

  Promise.all([fetchSMS, fetchEmail])
      .then(() => console.log('Both fetch requests completed'))
      .catch(error => console.error('Error in one or both fetch requests:', error));
    return () => {};
  }, []);

  const handleGoToMyOrder = () => {
    history.push({
      pathname: '/my-profile/my-booking',
      // pathname: ROUTE.MYPROFILE,
      // state: { tab: ProfileTabEnum.MyOrder },
    });
    window.location.reload();
  };

  const bookingId = queryParams.get("booking_id");
  const orderTotal = queryParams.get("order_total");
  const txnid = queryParams.get("txnid");

  return (
    <React.Fragment>
      <SeoAdd slug={ROUTE.PAYMENT_THANKYOU} />
      <BreadCrumb page={"Thank You"} data={{ slug: "", path: "" }} />
      {state?.type === "cod" ? (
      <section className={styles.background_box}>
        <div className="container text-center">
          <div className={styles.thankyou_box}>
            <div className="thank_container">
              <div>
                <h6>Dear {CustomerName},</h6>
                {/* <img
                  src="assets/img/my-profile/please.png"
                  className="scale"
                  style={{ maxWidth: "13%" }}
                /> */}
              </div>
              <div className="Cod-Content">
                <h4>We have received your order!</h4>
                <p>
                  Please note that your payment status is pending, and our team
                  is ready to help you complete the process. Feel Free to reach
                  out if you have any questions. We appreciate your trust in us.
                </p>
              </div>
              <img
                src="assets/img/my-profile/p_thank.png"
                className="scale mt-4"
                style={{ maxWidth: "40%" }}
              />
              <div className="booking-details">
                <p>
                  for choosing{" "}
                  <strong>
                    <i>Oncquest laboratories</i>
                  </strong>{" "}
                  as your healthcare partner.
                </p>
                <h6>Here are the details of your order:</h6>
                  <ul>
                    <li>
                      Booking ID: <span>{state?.bookingId}</span>
                    </li>
                  </ul>
              </div>
            </div>
            <h2 className={styles.payment_done}>
              {" "}
              <img
                src="assets/img/my-profile/ptick.png"
                width={24}
                height={24}
              />
              {state?.page === 'update' ?
                "Order has been Updated successfully."
                : "Order has been placed successfully."
              }
            </h2>
            {/* <div className="mt-3" style={{ color: "#514E4E" }}>
              It is a long established fact that a reader will be distracted by
              the readable content of a page when looking at its layout
            </div> */}
            <div className="text-center mt-1">
              <span
                onClick={handleGoToMyOrder}
                className="book--hexagon active"
              >
                <span className="text-capitalize">Go To My Order</span>
              </span>
            </div>
          </div>
        </div>
      </section>
      ) : (
      <section className={styles.background_box}>
        <div className="container text-center">
          <div className={styles.thankyou_box}>
            <div className="thank_container">
              <div>
                <h6>Dear {CustomerName},</h6>
                {/* <img
                  src="assets/img/my-profile/please.png"
                  className="scale"
                  style={{ maxWidth: "13%" }}
                /> */}
              </div>
              <div>
                <img
                  src="assets/img/my-profile/p_thank.png"
                  className="scale mt-4"
                  style={{ maxWidth: "40%" }}
                />
                <div className="booking-details">
                  <p>
                    for choosing{" "}
                    <strong>
                      <i>Oncquest laboratories</i>
                    </strong>{" "}
                    as your healthcare partner.
                  </p>
                  <p>We appreciate your trust in our services.</p>
                  <h6>Here are the details of your order:</h6>
                  <ul>
                    <li>
                      Booking ID: <span>{bookingId}</span>
                    </li>
                    <li>
                      Order Total: <span>₹{orderTotal ? Number(orderTotal)?.toFixed(2) : 0}</span>
                    </li>
                    <li>
                      Transaction/Reference Number: <span>{txnid}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <h2 className={styles.payment_done}>
              {" "}
              <img
                src="assets/img/my-profile/ptick.png"
                width={24}
                height={24}
              />
              {/* {state?.type == "cod"
                ? "Order has been placed successfully."
                : "Payment Done Successfully"} */}
                {state?.page === 'update' ?
                "Order has been Updated successfully."
                : "Payment Done Successfully"
              }
            </h2>
            {/* <div className="mt-3" style={{ color: "#514E4E" }}>
              It is a long established fact that a reader will be distracted by
              the readable content of a page when looking at its layout
            </div> */}
            <div className="text-center mt-1">
              <span
                onClick={handleGoToMyOrder}
                className="book--hexagon active"
              >
                <span className="text-capitalize">Go To My Order</span>
              </span>
            </div>
          </div>
        </div>
      </section>
      )}
    </React.Fragment>
  );
};

export default PaymentThankyou;
